module.exports = __webpack_public_path__ + "img/logout.d26d66fc.svg";